import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import MultifactorOptionsForms from "./multifactor-options-forms";
import { fetchMFAOptions } from "actions/multifactor";
import { Spinner } from "components/ui";

export default function MultifactorOptions() {
  const [patientInfo, setPatientInfo] = useState(null);
  const [isFetching, setIsFetching] = useState(false);
  const dispatch = useDispatch();

  const loadData = async () => {
    try {
      setIsFetching(true);
      const response = await dispatch(fetchMFAOptions());
      setPatientInfo(response);
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    loadData();
  }, [dispatch]);

  if (isFetching || !patientInfo) {
    return <Spinner style={{ marginTop: "1rem" }} />;
  }

  return (
    <MultifactorOptionsForms
      patientInfo={patientInfo}
      onPhoneUpdated={loadData}
    />
  );
}
